import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FilterDetail } from '../../../models/api/reports/filter-detail-response';
import { BaseComponent } from '../../base/base.component';
import { EmptyStateComponent } from '../../core/panels/empty-state.component';
import { LoadingPanelComponent } from '../../core/panels/loading-panel.component';

@Component({
  selector: 'app-filter-ref-view',
  imports: [CommonModule, EmptyStateComponent, LoadingPanelComponent],
  template: `
    @if (!dataSource) {
      <app-loading-panel
        state="Loading"
        loadingStyle="Box"
        [loadingHeight]="120"
      />
    } @else if (!hasReferences) {
      <app-empty-state
        label="No references"
        message="This filter is not referenced by any report"
        icon="fa-light fa-file"
        height="120px"
      />
    } @else {
      <div>This filter is referenced by the following reports:</div>
      <ul
        class="tw-ml-4 tw-p-4 tw-font-bold"
        style="list-style-type: disc;"
        role="list"
        aria-label="References"
      >
        @for (report of reports; track $index) {
          <li class="tw-py-0.5" role="listitem">{{ report }}</li>
        }
      </ul>
      <div class="tw-italic tw-text-sm tw-py-2">
        Filters cannot be deleted when referenced by a report.
      </div>
    }
  `,
  styles: ``,
})
export class FilterRefViewComponent extends BaseComponent {
  @Input()
  dataSource: FilterDetail;

  get hasReferences(): boolean {
    return !!(
      this.dataSource?.reportsUsingThisFilter &&
      this.dataSource.reportsUsingThisFilter.length > 0
    );
  }

  get reports(): string[] {
    return this.dataSource?.reportsUsingThisFilter || [];
  }
}
